import { withBoxComponent, MODAL } from '../../../../components/box-component/with-box-component.mobile';
import PaymentMethods from '../../../../components/payment-methods/payment-methods.mobile';
import paymentMethods from './payment-methods';

const PaymentMethodsBox = withBoxComponent(MODAL)(PaymentMethods);

export default paymentMethods(PaymentMethodsBox);
